import { render, staticRenderFns } from "./Bestellung.vue?vue&type=template&id=f56f3166"
import script from "./Bestellung.vue?vue&type=script&lang=ts"
export * from "./Bestellung.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports